import { Button } from '@barfacil/barfacil-ui'
import { FileUp } from 'lucide-react'

import { ConfigurePriceListDialog } from '@/app/panel/management/price-list/_components/configure-price-list-dialog'
import { CreatePriceListDialog } from '@/app/panel/management/price-list/_components/create-price-list-dialog'
import { PriceListFilterSearch } from '@/app/panel/management/price-list/_components/filter-search'
import { usePriceListContext } from '@/app/panel/management/price-list/_contexts/price-list-context'

export const PriceListHeader = () => {
  const { setFilters, priceListInfinite } = usePriceListContext()

  return (
    <header className="flex flex-col gap-4 lg:flex-row">
      <PriceListFilterSearch
        setFilters={setFilters}
        isFetching={priceListInfinite.isLoading}
        className="lg:max-w-96"
      />

      <div className="flex flex-col gap-4 sm:flex-row sm:gap-2">
        <CreatePriceListDialog />

        <ConfigurePriceListDialog />

        <Button
          className="max-w-min gap-2"
          variant="secondary"
          isCustom
          disabled
        >
          <FileUp size={16} />
          IMPORTAR CARDÁPIO
        </Button>
      </div>
    </header>
  )
}
